// extracted by mini-css-extract-plugin
export default {"container":"Read_container__OqAky","list":"Read_list__1101q"};